/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Roles, RolesInterface } from "../Roles";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArraysDifferentLength",
    type: "error",
  },
  {
    inputs: [],
    name: "ModuleTransactionFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16[]",
        name: "roles",
        type: "uint16[]",
      },
      {
        indexed: false,
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "AssignRoles",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousAvatar",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newAvatar",
        type: "address",
      },
    ],
    name: "AvatarSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "guard",
        type: "address",
      },
    ],
    name: "ChangedGuard",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "DisabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "EnabledModule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "initiator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "avatar",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "target",
        type: "address",
      },
    ],
    name: "RolesModSetup",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint16",
        name: "defaultRole",
        type: "uint16",
      },
    ],
    name: "SetDefaultRole",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "multisendAddress",
        type: "address",
      },
    ],
    name: "SetMultisendAddress",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousTarget",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newTarget",
        type: "address",
      },
    ],
    name: "TargetSet",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "allowTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "uint16[]",
        name: "_roles",
        type: "uint16[]",
      },
      {
        internalType: "bool[]",
        name: "memberOf",
        type: "bool[]",
      },
    ],
    name: "assignRoles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "avatar",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "defaultRoles",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "prevModule",
        type: "address",
      },
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "disableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
    ],
    name: "enableModule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModule",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
    ],
    name: "execTransactionFromModuleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRole",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
      {
        internalType: "enum Enum.Operation",
        name: "operation",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "bool",
        name: "shouldRevert",
        type: "bool",
      },
    ],
    name: "execTransactionWithRoleReturnData",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "returnData",
        type: "bytes",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getGuard",
    outputs: [
      {
        internalType: "address",
        name: "_guard",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "start",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pageSize",
        type: "uint256",
      },
    ],
    name: "getModulesPaginated",
    outputs: [
      {
        internalType: "address[]",
        name: "array",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "next",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "guard",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_module",
        type: "address",
      },
    ],
    name: "isModuleEnabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "multisend",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "revokeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeAllowFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "bool[]",
        name: "isParamScoped",
        type: "bool[]",
      },
      {
        internalType: "enum ParameterType[]",
        name: "paramType",
        type: "uint8[]",
      },
      {
        internalType: "enum Comparison[]",
        name: "paramComp",
        type: "uint8[]",
      },
      {
        internalType: "bytes[]",
        name: "compValue",
        type: "bytes[]",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "enum ExecutionOptions",
        name: "options",
        type: "uint8",
      },
    ],
    name: "scopeFunctionExecutionOptions",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "paramIndex",
        type: "uint256",
      },
      {
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        internalType: "enum Comparison",
        name: "paramComp",
        type: "uint8",
      },
      {
        internalType: "bytes",
        name: "compValue",
        type: "bytes",
      },
    ],
    name: "scopeParameter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint256",
        name: "paramIndex",
        type: "uint256",
      },
      {
        internalType: "enum ParameterType",
        name: "paramType",
        type: "uint8",
      },
      {
        internalType: "bytes[]",
        name: "compValues",
        type: "bytes[]",
      },
    ],
    name: "scopeParameterAsOneOf",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
    ],
    name: "scopeRevokeFunction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
    ],
    name: "scopeTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_avatar",
        type: "address",
      },
    ],
    name: "setAvatar",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "module",
        type: "address",
      },
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
    ],
    name: "setDefaultRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_guard",
        type: "address",
      },
    ],
    name: "setGuard",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_multisend",
        type: "address",
      },
    ],
    name: "setMultisend",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_target",
        type: "address",
      },
    ],
    name: "setTarget",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initParams",
        type: "bytes",
      },
    ],
    name: "setUp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "target",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "role",
        type: "uint16",
      },
      {
        internalType: "address",
        name: "targetAddress",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "functionSig",
        type: "bytes4",
      },
      {
        internalType: "uint8",
        name: "paramIndex",
        type: "uint8",
      },
    ],
    name: "unscopeParameter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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$26c8ee7675adcd4387514ebc7646e15ffa$__63a2f6f6d0606b60008661ffff1661ffff1681526020019081526020016000208585856040518563ffffffff1660e01b81526004016108619493929190615578565b60006040518083038186803b15801561087957600080fd5b505af415801561088d573d6000803e3d6000fd5b50505050505050565b61089e613008565b73ffffffffffffffffffffffffffffffffffffffff166108bc612057565b73ffffffffffffffffffffffffffffffffffffffff1614610912576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016109099061519e565b60405180910390fd5b80606a60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548161ffff021916908361ffff1602179055507f197e61bb67ba4b0f657afcb5d2dbed385d50b697c51090f466cdbcc4c30a21ce828260405161099d929190614f51565b60405180910390a15050565b6109b1613008565b73ffffffffffffffffffffffffffffffffffffffff166109cf612057565b73ffffffffffffffffffffffffffffffffffffffff1614610a25576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610a1c9061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63163592dd606b60008761ffff1661ffff168152602001908152602001600020868686866040518663ffffffff1660e01b8152600401610a7e9594939291906153d3565b60006040518083038186803b158015610a9657600080fd5b505af4158015610aaa573d6000803e3d6000fd5b5050505050505050565b610abc613008565b73ffffffffffffffffffffffffffffffffffffffff16610ada612057565b73ffffffffffffffffffffffffffffffffffffffff1614610b30576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610b279061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__6377cff804606b60008661ffff1661ffff1681526020019081526020016000208585856040518563ffffffff1660e01b8152600401610b8794939291906152df565b60006040518083038186803b158015610b9f57600080fd5b505af4158015610bb3573d6000803e3d6000fd5b50505050505050565b606960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b606a6020528060005260406000206000915054906101000a900461ffff1681565b60008173ffffffffffffffffffffffffffffffffffffffff16600173ffffffffffffffffffffffffffffffffffffffff1614158015610cce5750600073ffffffffffffffffffffffffffffffffffffffff16606860008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614155b9050919050565b610cdd613008565b73ffffffffffffffffffffffffffffffffffffffff16610cfb612057565b73ffffffffffffffffffffffffffffffffffffffff1614610d51576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d489061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__633c5a24e2606b60008761ffff1661ffff168152602001908152602001600020868686866040518663ffffffff1660e01b8152600401610daa959493929190615525565b60006040518083038186803b158015610dc257600080fd5b505af4158015610dd6573d6000803e3d6000fd5b5050505050505050565b610de8613008565b73ffffffffffffffffffffffffffffffffffffffff16610e06612057565b73ffffffffffffffffffffffffffffffffffffffff1614610e5c576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610e539061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__635ebbaa68606b60008761ffff1661ffff168152602001908152602001600020868686866040518663ffffffff1660e01b8152600401610eb59594939291906153d3565b60006040518083038186803b158015610ecd57600080fd5b505af4158015610ee1573d6000803e3d6000fd5b5050505050505050565b610ef3613008565b73ffffffffffffffffffffffffffffffffffffffff16610f11612057565b73ffffffffffffffffffffffffffffffffffffffff1614610f67576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f5e9061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__632af6aecb606b60008e61ffff1661ffff1681526020019081526020016000208d8d8d8d8d8d8d8d8d8d8d6040518d63ffffffff1660e01b8152600401610fce9c9b9a99989796959493929190615324565b60006040518083038186803b158015610fe657600080fd5b505af4158015610ffa573d6000803e3d6000fd5b505050505050505050505050505050565b611013613008565b73ffffffffffffffffffffffffffffffffffffffff16611031612057565b73ffffffffffffffffffffffffffffffffffffffff1614611087576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161107e9061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63edf909e3606b60008b61ffff1661ffff1681526020019081526020016000208a8a8a8a8a8a8a8a6040518a63ffffffff1660e01b81526004016110e89998979695949392919061549e565b60006040518083038186803b15801561110057600080fd5b505af4158015611114573d6000803e3d6000fd5b505050505050505050505050565b60008073ffffffffffffffffffffffffffffffffffffffff16606860003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1614156111f2576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016111e9906151be565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63db50e575606b6000606a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900461ffff1661ffff1661ffff168152602001908152602001600020606960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1689898989896040518863ffffffff1660e01b81526004016112be979695949392919061523e565b60006040518083038186803b1580156112d657600080fd5b505af41580156112ea573d6000803e3d6000fd5b5050505061133e868686868080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f8201169050808301925050505050505085613010565b905095945050505050565b611351613008565b73ffffffffffffffffffffffffffffffffffffffff1661136f612057565b73ffffffffffffffffffffffffffffffffffffffff16146113c5576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016113bc9061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63cfe4317a606b60008561ffff1661ffff16815260200190815260200160002084846040518463ffffffff1660e01b815260040161141a939291906152a8565b60006040518083038186803b15801561143257600080fd5b505af4158015611446573d6000803e3d6000fd5b505050505050565b60006060600073ffffffffffffffffffffffffffffffffffffffff16606860003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff161415611521576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611518906151be565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__63db50e575606b6000606a60003373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900461ffff1661ffff1661ffff168152602001908152602001600020606960009054906101000a900473ffffffffffffffffffffffffffffffffffffffff168a8a8a8a8a6040518863ffffffff1660e01b81526004016115ed979695949392919061523e565b60006040518083038186803b15801561160557600080fd5b505af4158015611619573d6000803e3d6000fd5b5050505061166d878787878080601f016020809104026020016040519081016040528093929190818152602001838380828437600081840152601f19601f8201169050808301925050505050505086613305565b915091509550959350505050565b606660009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b6116a9613008565b73ffffffffffffffffffffffffffffffffffffffff166116c7612057565b73ffffffffffffffffffffffffffffffffffffffff161461171d576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016117149061519e565b60405180910390fd5b73__$26c8ee7675adcd4387514ebc7646e15ffa$__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__$26c8ee7675adcd4387514ebc7646e15ffa$__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__$26c8ee7675adcd4387514ebc7646e15ffa$__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__$26c8ee7675adcd4387514ebc7646e15ffa$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";

type RolesConstructorParams =
  | [linkLibraryAddresses: RolesLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RolesConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class Roles__factory extends ContractFactory {
  constructor(...args: RolesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, Roles__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = "Roles";
  }

  static linkBytecode(linkLibraryAddresses: RolesLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$26c8ee7675adcd4387514ebc7646e15ffa\\$__", "g"),
      linkLibraryAddresses["contracts/Permissions.sol:Permissions"]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    _owner: string,
    _avatar: string,
    _target: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Roles> {
    return super.deploy(
      _owner,
      _avatar,
      _target,
      overrides || {}
    ) as Promise<Roles>;
  }
  getDeployTransaction(
    _owner: string,
    _avatar: string,
    _target: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _owner,
      _avatar,
      _target,
      overrides || {}
    );
  }
  attach(address: string): Roles {
    return super.attach(address) as Roles;
  }
  connect(signer: Signer): Roles__factory {
    return super.connect(signer) as Roles__factory;
  }
  static readonly contractName: "Roles";
  public readonly contractName: "Roles";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RolesInterface {
    return new utils.Interface(_abi) as RolesInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Roles {
    return new Contract(address, _abi, signerOrProvider) as Roles;
  }
}

export interface RolesLibraryAddresses {
  ["contracts/Permissions.sol:Permissions"]: string;
}
